import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';

import { DocsSearchService } from '../../docs-search';

/** "Indexing x of y" while the local indexer still works through docs. */
export function useIndexerSummary(): string | null {
  const i18n = useI18n();
  const indexerState = useLiveData(useService(DocsSearchService).indexerState$);
  const total = indexerState.total ?? 0;
  if (indexerState.completed || total === 0) return null;
  const pending = indexerState.indexing ?? 0;
  return i18n.t({
    i18nKey: 'com.streamlain.quicksearch.advanced.indexing',
    options: { done: Math.max(0, total - pending), total },
  });
}
